module.exports = __webpack_public_path__ + "img/logo-white.5b40a15d.svg";